import React, { useContext, useEffect, useState } from "react";
import MyContext from "../../../StoreContext";
import loading from "./assets/loading.gif";
import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";

const category = {
  max: "Oportunidad comercial",
  blockcard: "Bloqueo de tarjeta",
  stolen: "Robo de tarjeta",
  consult: "Consulta",
  extension: "Extensión",
  include: "Incluir",
  order: "Orden",
  claim: "Reclamo",
  address: "Dirección",
};

const categoryTitle = {
  fontSize: "24px",
  fontWeight: "600",
  fontFamily: "Asap",
  lineHeight: "20px",
  color: "#443B91",
  marginBottom: "8px",
};

const categorySubtitle = {
  fontSize: "20px",
  fontWeight: "500",
  fontFamily: "Asap",
  lineHeight: "20px",
};

/**
 * Este componente loader se encarga de mostrar un gif que simula
 * el procesamiento de la solucion para luego mostrar la categoria
 * resultante del procesamiento
 */
const Loader = () => {
  const [showLoader, setShowLoader] = useState(true);
  const { message, channel, updateShowPlatform } = useContext(MyContext);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
      updateShowPlatform(true);
      console.log("loading...");
    }, 3500);
    return () => {
      clearTimeout(timer);
      setShowLoader(true);
      updateShowPlatform(false);
    };
  }, [message, channel]);

  if (showLoader) {
    return <img src={loading} alt='Carga' width={150} />;
  } else {
    return (
      <Grid>
        <Typography sx={categoryTitle}>Categoria:</Typography>
        <Typography sx={categorySubtitle}>
          {category[message as keyof typeof category]}
        </Typography>
      </Grid>
    );
  }
};

export default Loader;
